const cinemaTilePromise = "cinemaTilePromise";
export default cinemaTilePromise;
